import type { JDSAvatarV2CompleteRingProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSAvatarV2CompleteRingProps>
  ): React.FC<JDSAvatarV2CompleteRingProps> =>
  (props: JDSAvatarV2CompleteRingProps) => {
    return <Component {...props} />;
  };
